// extracted by mini-css-extract-plugin
export default {"button":"button_button__Z9kQm","round":"button_round__xVUhc","roundLg":"button_roundLg__d+sfP","icon":"button_icon__2B+C-","tab":"button_tab__wiFpy"};